<template>
  <div class="page-container">

    <MainContentHome :mainPublication="mainPublication" :imageLoading="isMainImageLoading" />

    <div class="mb-4">
      <section class="page-header">
        <h2 class="font-weight-bold">Acesso rápido</h2>
      </section>
      <div class="separator-line"></div>
    </div>
    <section>
      <div class="card-container pb-4">
        <CustomInfoCard class="deck" v-for="card in getCards" :key="card.id" :onCardClick="() => onClickCard(card)"
          :headerIcon="card.headerIcon" :title="card.header" :description="card.description" :icon="card.icon"
          :featureName="card.featureName" />
      </div>
    </section>

    <ConnectionHome v-if="homeDataConnection" :connectionData="homeDataConnection" :loadingNewsIds="loadingNewsIds" />

    <Footer />
  </div>
</template>

<script>
import CustomInfoCard from "../../../components/custom-info-card/CustomInfoCard.vue";
import MainContentHome from "../components/MainContentHome.vue";
import ConnectionHome from "../components/ConnectionHome.vue";

import RoutesPaths from "../../../router/router-structure/routes-paths";
import { isMobile } from "../../../utils/mobile/mobile";
import { APP_WHATSAPP_CHAT_URL } from "../../../services/urls/enviroment-variables";
import { APP_CONTACT_PHONE_NUMBER } from "../../../services/urls/enviroment-variables";
import { formatFone } from "../../../utils/format/formtUtils";
import { getLinkByCode } from "../../../utils/links-external/links-external-utils";
import { getHomeData } from "../../../services/connection/ConnectionService";
import Footer from '../../../layouts/Footer.vue';
import coverImageMixin from "../../connection/mixins/coverImageMixin";

export default {
  components: {
    CustomInfoCard,
    MainContentHome,
    ConnectionHome,
    Footer
  },
  mixins: [coverImageMixin],
  data() {
    return {
      isLoading: true,
      homeDataConnection: null,
      mainPublication: {
        id: null,
        title: '',
        resume: '',
        image: null
      },
      mainPublicationImageSrc: null,
      isMainImageLoading: true,
      loadingNewsIds: []
    }
  },
  computed: {
    getCards: () => {
      let cards = [
        {
          id: 0,
          icon: "analitycs-card.svg",
          header: "Analítica",
          description:
            "Tenha acesso a analítica financeira E gerencie seus ganhos",
          route: RoutesPaths.financial.analytics(),
          showMobile: true,
          featureName: "HOME_CARD_ANALYTICS",
        },
        {
          id: 1,
          icon: "training-icon.svg",
          header: "Treinamentos",
          description:
            "Aqui oferecemos uma ampla variedade de cursos e treinamentos abordando temas diversos",
          route: RoutesPaths.trainingPage.rootName(),
          showMobile: false,
          featureName: "HOME_CARD_TRAINING",
        },
        {
          id: 2,
          icon: "panel-economic.svg",
          header: "Painel Econômico",
          description:
            "Acesse os principais resultados financeiros e administrativos da cooperativa",
          route: RoutesPaths.institutionalPage.panelEconomic(),
          showMobile: true,
          featureName: "HOME_CARD_PAINEL_ECONOMIC",
        },
        {
          id: 3,
          icon: "docs-outline.svg",
          header: "Documentos e Atas UGF",
          description: "Consulte atas, relatórios, consensos, políticas, tabelas, cronogramas e outros documentos.",
          route: RoutesPaths.documentsAtasPage.documentsAtas(),
          showMobile: true,
          featureName: "HOME_CARD_DOCUMENT_CARD",
        },
        {
          id: 4,
          icon: "surgical-consent-form.svg",
          header: "Formulários e Termo de Consentimento Cirúrgico",
          description:
            "Acesse os formulários necessários para solicitar procedimento aos seus pacientes.",
          typeLink: "SURGICAL_CONSENT",
          showMobile: false,
          featureName: "HOME_CARD_SURGICAL_CONSENT",
        },
        {
          id: 5,
          icon: "income-history.svg",
          header: "Histórico de Notas Fiscais",
          description: "Confira a validação de suas notas de produção e acompanhe as datas de entrega.",
          route: RoutesPaths.financial.incomeHistory(),
          showMobile: true,
          featureName: "HOME_CARD_INCOME_HISTORY",
        },
        {
          id: 6,
          icon: "icon-register.svg",
          header: "Cadastro",
          description:
            "Mantenha seus dados atualizados para garantir a regularidade de seus pagamentos e comunicações.",
          route: RoutesPaths.register.rootName(),
          showMobile: true,
          featureName: "HOME_CARD_REGISTER",
        },
        {
          id: 7,
          icon: "forward-inbox.svg",
          header: "Outras Solicitações",
          description:
            "Aqui você pode protocolar suas solicitações para a área do cooperado.",
          route: RoutesPaths.benefit.otherSolicitation(),
          showMobile: true,
          featureName: "HOME_CARD_EMAIL_OUTLINE",
        },
      ];
      if (isMobile()) {
        return cards.filter((c) => c.showMobile);
      }
      return cards;
    },
    formattedContactPhone() {
      return formatFone(APP_CONTACT_PHONE_NUMBER);
    },
  },
  methods: {
    isMobile: isMobile,
    onClickCard({ route, typeLink }) {
      if (typeLink) {
        const link = getLinkByCode(typeLink);
        window.open(link, "_blank");
      } else if (route) this.$router.push(route);
    },
    onClickWhatzapp() {
      window.open(APP_WHATSAPP_CHAT_URL, "_blank");
    },
    async loadMainContent() {
      try {
        this.isLoading = true;
        const response = await getHomeData();
        const data = response.data;

        // 1. Atualizamos os dados brutos (texto)
        this.homeDataConnection = data;
        if (data.featuredContent) {
          this.mainPublication.id = data.featuredContent.id;
          this.mainPublication.title = data.featuredContent.title;
          this.mainPublication.resume = data.featuredContent.coverCallout;
          this.mainPublication.image = data.featuredContent.image ?? null;
          this.isMainImageLoading = false;
        }

        // 2. Liberamos a interface (Esqueletos de imagem aparecem, texto fixa)
        this.isLoading = false;

        // 3. AGUARDAMOS o DOM estabilizar antes de iniciar as imagens
        this.$nextTick(() => {
          this.processImagesInBackground();
        });

      } catch (error) {
        console.error("Erro:", error);
        this.isLoading = false;
      }
    },
    async processImagesInBackground() {

      // 2. Tratamento das Notícias
      if (this.homeDataConnection.news) {
        // Inicializa a lista de IDs que estão carregando
        this.loadingNewsIds = this.homeDataConnection.news.map(n => n.id);
        this.homeDataConnection.news.forEach(async (item, index) => {
          try {
            const src = await this.loadCoverImage(item.coverImageUrl);
            this.$set(this.homeDataConnection.news[index], 'image', src);
          } finally {
            // Remove o ID da lista de carregamento assim que termina
            this.loadingNewsIds = this.loadingNewsIds.filter(id => id !== item.id);
          }
        });
      }

      if (this.homeDataConnection.articles) {
        this.homeDataConnection.articles.forEach(async (item, index) => {
          if (item.authorImageUrl) {
            try {
              const src = await this.loadCoverImage(item.authorImageUrl);
              this.$set(this.homeDataConnection.articles[index], 'authorImageUrl', src);
            } catch (e) {
              console.error("Erro ao carregar imagem de autor do artigo:", e);
            }
          }
        });
      }
    }
  },
  beforeDestroy() {
    this._revokeCoverImages();
  },
  mounted() {
    this.loadMainContent();
  },
};
</script>

<style lang="scss" scoped>
.deck-margin {
  margin: 2rem;
}

.page-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.page-header {
  text-align: center;
}

.sub-header {
  max-width: 83rem;
  margin: 0 auto;
  margin-top: 1.5rem;
  text-align: center;
}


.card-container {
  max-width: 100rem;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;

  // Reduzir o gap no mobile ajuda a ganhar espaço para os cards
  @include media-breakpoint-down(sm) {
    gap: 16px;
    padding-left: 10px; // Padding lateral para os cards não colarem na borda da tela
    padding-right: 10px;
  }
}

.deck {
  flex: 1 1 20rem;
  max-width: 23rem;

  // Ajuste para Mobile (Geralmente abaixo de 576px ou 768px)
  @include media-breakpoint-down(sm) {
    // Calculamos 50% da largura subtraindo metade do gap (12px)
    // para que dois cards caibam perfeitamente na linha
    flex: 1 1 calc(50% - 12px);
    max-width: calc(50% - 12px);
    min-width: 140px; // Garante que não fiquem pequenos demais em telas muito estreitas
  }
}

.pointer {
  cursor: pointer;
}

@include media-breakpoint-down(lg) {
  .page-footer {
    position: relative;
  }
}

@include media-breakpoint-up(lg) {
  .page-footer {
    position: fixed;
  }
}

.page-footer {
  display: flex;
  justify-content: center;
  align-items: center;

  bottom: 0;
  width: 100%;
}

.p-footer {
  text-align: center;
}
</style>
